import React from 'react'
import { connect } from 'react-redux'
import EventsActions from '../../Redux/EventsRedux'

class EventsCategories extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      showModal: null,
      detail: {},
      page: 1
    }
  }

  componentDidMount = () => {
    this._fetchEventsCategories()
  }

  _fetchEventsCategories = (event) => {
    if (event) {
      event.preventDefault()
    }
    this.props.getEventsCategories()
  }

  render () {
    const { events } = this.props
    return (
      <div>
        <header className='section'>
          <div className='title-block d-flex mb-3 justify-content-between'>
            <h3 className='title mr-auto'>Events Categories
              {
                (events.fetching || events.processing) &&
                <div className='badge badge-info ml-2'>{ events.fetching ? 'Loading' : 'Processing' } ...</div>
              }
            </h3>
          </div>
        </header>

        <section className='section' style={{ width: '50%' }}>
          <div className='card'>
            {
              !(events.fetching || events.processing) && events.err &&
              <div className='alert alert-danger'>{events.err}</div>
            }
            <table className='table table-hover table-striped' style={{ minWidth: '100%' }}>
              <thead>
                <tr>
                  <th className='text-center'>Category Name</th>
                  <th className='text-center'>Category Status</th>
                </tr>
              </thead>
              <tbody>
                {
                  !events.data_category || events.data_category.length === 0
                    ? <tr>
                      <td colSpan='3' className='text-center'>--No Data--</td>
                    </tr>
                    : events.data_category.length && events.data_category.map((item, i) => (
                      <tr key={i}>
                        <td className='text-center'>{item.name}</td>
                        <td className='text-center'>
                          {
                            item.status === true ? 'Active' : 'Inactive'
                          }
                        </td>
                      </tr>
                    ))
                }
              </tbody>
            </table>
          </div>
        </section>
      </div>
    )
  }
}

const stateToProps = (state) => ({
  events: state.events
})

const dispatchToProps = (dispatch) => ({
  getEventsCategories: (data) => dispatch(EventsActions.getEventsCategoriesRequest(data))
})

export default connect(stateToProps, dispatchToProps)(EventsCategories)



// WEBPACK FOOTER //
// ./src/Pages/Events/EventsCategories.js